import { createI18n } from 'vue-i18n'
import pl from './pl'
import en from './en'
import uk from './uk'
import es from './es'
import plPrimeVue from './primevue-pl'
import enPrimeVue from './primevue-en'
import ukPrimeVue from './primevue-uk'
import esPrimeVue from './primevue-es'

export function detectBrowserLocale() {
  const saved = localStorage.getItem('enercare-locale')
  if (saved) return saved

  const supported = ['pl', 'en', 'uk', 'es']
  const browserLang = navigator.language?.split('-')[0]
  return supported.includes(browserLang) ? browserLang : 'pl'
}

const savedLocale = detectBrowserLocale()

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'pl',
  messages: {
    pl,
    en,
    uk,
    es
  }
})

// PrimeVue locales
export const primeVueLocales = {
  pl: plPrimeVue,
  en: enPrimeVue,
  uk: ukPrimeVue,
  es: esPrimeVue
}

// Helper to get current PrimeVue locale
export const getPrimeVueLocale = (locale) => {
  return primeVueLocales[locale] || primeVueLocales.pl
}

export default i18n
